/**
 * @author Fernando Ruano
 * @file index.jsx
 * @description Dashboard Container.
 */

// Dependencies
import React from 'react';
import { Drawer } from 'antd';
import PropTypes from 'prop-types';

// Components
import SiderComponent from '../SiderComponent';

const DrawerComponent = ({
  setVisible,
  onBreak,
  onCollapse,
  visible,
  routes,
  signOut
}) => {
  return (
    <Drawer
      placement="left"
      closable={false}
      onClose={() => setVisible(false)}
      visible={visible}
      bodyStyle={{ padding: 0 }}
      contentWrapperStyle={{
        width: 230,
        boxShadow: visible && '4px 0px 4px rgb(0 51 153 / 30%)'
      }}
      key={'left'}>
      <div className="h-full w-full">
        <SiderComponent
          broken={false}
          onBreak={onBreak}
          collapsed={false}
          onCollapse={onCollapse}
          onShowDrawer={setVisible}
          visible={visible}
          signOut={signOut}
          routes={routes}
        />
      </div>
    </Drawer>
  );
};

/**
 * @name DrawerComponent.propTypes
 * @type { propTypes } React PropTypes.
 * @property { Boolean } visible - Is drawer collapsed boolean.
 * @property { Array } routes - Routes array.
 * @property { Object } onCollapse - Collapse function.
 * @property { Object } setVisible - Visible Drawer function.
 * @property { function } intl - React-intl prop.
 */
DrawerComponent.propTypes = {
  onBreak: PropTypes.func,
  onCollapse: PropTypes.func,
  setVisible: PropTypes.func,
  visible: PropTypes.bool,
  signOut: PropTypes.func,
  routes: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string,
      path: PropTypes.string,
      isProtected: PropTypes.bool,
      component: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
      intlId: PropTypes.string,
      icon: PropTypes.object,
      exact: PropTypes.bool
    })
  ),
  location: PropTypes.any
};

/**
 * Initialize default properties.
 */
DrawerComponent.defaultProps = {
  collapsed: false,
  broken: false,
  visible: false,
  route: []
};

export default DrawerComponent;
